import React from 'react';
import {useIntl} from 'react-intl';
import {LiteEmptyPage} from './LiteEmptyPage';

export const LiteSolutionInfo = () => {
  const intl = useIntl();
  return (
    <LiteEmptyPage>
      <h5>{intl.formatMessage({id: 'studioLite.solutions.header'})}</h5>
      <p>{intl.formatMessage({id: 'studioLite.solutions.1'})}</p>
      <p>
        {intl.formatMessage(
          {id: 'studioLite.solutions.2'},
          {
            learnLink: (
              <a
                href="https://www.blaize.com/products/ai-studio/#marketplace"
                target="_blank"
                rel="noreferrer"
              >
                here
              </a>
            ),
          }
        )}
      </p>
    </LiteEmptyPage>
  );
};
